import { Text } from "@chakra-ui/react"

export const ErrorText = ({ children }: { children: React.ReactNode }) => {
  return <Text color="red.500">{children}</Text>
}
